<template>
  <select-with-buttons :options="options" :row-size="rowSize"
                       @click="propagateClick"></select-with-buttons>
</template>

<script>
import SelectWithButtons from '../lib/SelectWithButtons';

const RANKS = ['A', 'K', 'Q', 'J', '10', '9', '8', '7', '6', '5', '4', '3', '2'];

export default {
  name: 'SelectRank',
  components: {SelectWithButtons},
  props: {
    disabledRanks: {type: Array, default: () => []},
    rowSize: {default: Infinity}
  },
  computed: {
    options() {
      return RANKS.map(key => ({
        value: key,
        text: key,
        class: ['scoreButton'],
        disabled: this.disabledRanks.includes(key)
      }));
    }
  },
  methods: {
    propagateClick(clicked) {
      this.$emit('click', clicked);
    }
  }
};
</script>

<style scoped>
>>> .scoreButton {
  background: #fff;
  border: 1.5px solid #1e3a5f;
  color: #1e3a5f;
  font-weight: 600;
}
</style>